import { Pickup } from 'types/pickup';
import { StatusChip } from 'components/common/StatusChip';

export function PickupStatus({ pickup }: { pickup: Pickup }) {
  return <StatusChip status={pickup.state || 'pending_confirmation'} />;
}
